import injectSheet from 'react-jss'
import styles from './parent-app.styles'
import React, { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import Header from './header/header'
import {
  UserProvider,
  UserInspector,
  useMe
} from 'pobble-components/dist/pobble-user'
import { ConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { ToastContainer } from 'pobble-components/dist/toast'
import EnvironmentLine from 'pobble-components/dist/environment-line'
import PageNotFound from 'pobble-components/dist/page-not-found'
import { SubscriptionProvider } from 'pobble-components/dist/subscriptions'
import PresentModeProvider from '../pages/direct-present/present-mode.provider'
import PrintPreview from '../pages/print-preview/print-preview'
import { ErrorBoundary } from 'pobble-components/dist/error-boundary'
import { ParentLessonSelector } from '../pages/parent/parent-lesson-selector'
import { ParentLessons } from '../pages/parent/parent-lessons'
import { ParentWriting } from '../pages/parent/parent-writing'
import { ParentPrompt } from '../pages/parent/parent-prompt'
import { ParentRestrictedModal } from './parent-restricted-modal'

import posthog from 'posthog-js'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'

const APP_PATH = process.env.REACT_APP_PATH || '/'

function PostHogIdentity() {
  const { me } = useMe()
  const { hasAccessToTL, hasAccessToPH, freeTrial } = useSubscriptionDetails()

  useEffect(
    () => {
      if (me) {
        const account = me.account
        posthog.identify(account.id, {
          email: account.email_identity?.email,
          name: account.full_name,
          role: account.role_in_life,
          createdAt: account.created_at,
          hasAccessToTL,
          hasAccessToPH,
          freeTrial
        })
        posthog.capture('landed on parent spa', {
          url: window.location.href
        })
      }
    },
    [me, hasAccessToTL, hasAccessToPH, freeTrial]
  )

  return null
}

const ParentApp = ({ classes, me, meError }) => (
  <UserProvider
    fetchMe={() => {
      if (me) {
        return Promise.resolve(me)
      } else {
        return Promise.reject(meError)
      }
    }}>
    <PostHogIdentity />
    <ParentRestrictedModal />
    <SubscriptionProvider>
      <EnvironmentLine />
      <Router basename={APP_PATH}>
        <PresentModeProvider>
          <Header />
          <ErrorBoundary>
            <Switch>
              <UserInspector
                authRedirect={false}
                haveRights={me => me.account.policy.can_use_pobble_home}>
                <div className={classes.appHolder}>
                  <Switch>
                    <Redirect exact from="/" to="/parent" />
                    <Redirect exact from="/lesson" to="/parent" />
                    <Redirect exact from="/prompt" to="/parent" />
                    <Route
                      exact
                      path="/parent"
                      component={ParentLessonSelector}
                    />
                    <Route
                      exact
                      path="/parent/saved"
                      component={ParentLessons}
                    />
                    <Route path="/parent/lesson/:id" component={ParentPrompt} />
                    <Route
                      path="/parent/writing/:id"
                      component={ParentWriting}
                    />
                    <Route path="/print-preview/:id" component={PrintPreview} />
                    <Route component={PageNotFound} />
                  </Switch>
                </div>
              </UserInspector>
            </Switch>
          </ErrorBoundary>
          <ConfirmationDialog />
          <ToastContainer />
        </PresentModeProvider>
      </Router>
    </SubscriptionProvider>
  </UserProvider>
)

export default injectSheet(styles)(ParentApp)
